import moment from 'moment';

// Abbreviated so the longest date still fits the picker's half-width inputs without clipping the year.
export const TYPED_DATE_DISPLAY_FORMAT = 'MMM D, YYYY';

// Strict M and D tokens reject a leading zero, so partly padded input like 09/5 needs its own formats.
const ACCEPTED_FORMATS = [
	TYPED_DATE_DISPLAY_FORMAT,
	'MMMM Do, YYYY',
	'MMMM D, YYYY',
	'MMMM DD, YYYY',
	'MMM Do, YYYY',
	'MMM DD, YYYY',
	'MM/DD/YYYY',
	'M/D/YYYY',
	'MM/D/YYYY',
	'M/DD/YYYY',
	'MM-DD-YYYY',
	'M-D-YYYY',
	'MM-D-YYYY',
	'M-DD-YYYY',
	'YYYY-MM-DD',
	'YYYY/MM/DD',
	'MM/DD/YY',
	'M/D/YY',
	'MM/D/YY',
	'M/DD/YY',
	'MM-DD-YY',
	'M-D-YY',
	'MM-D-YY',
	'M-DD-YY',
];

const EARLIEST_YEAR = 1900;
const LATEST_YEAR = 2100;

export const parseTypedDate = (value: string): moment.Moment | null => {
	const trimmed = value.trim();
	if (!trimmed) {
		return null;
	}

	const parsed = moment(trimmed, ACCEPTED_FORMATS, true);
	if (!parsed.isValid()) {
		return null;
	}

	const year = parsed.year();
	if (year < EARLIEST_YEAR || year > LATEST_YEAR) {
		return null;
	}

	return parsed;
};
